import "../../assets/css/panel-tile.css";
import PanelTile from "./PanelTile";
import { shimmerWrapper } from "../Shimmer/Shimmer";

const wrappedPanelTile = shimmerWrapper(PanelTile);

export { wrappedPanelTile as PanelTile };
  
export default wrappedPanelTile;